import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="text-xl font-bold text-gray-900 tracking-tight">
              SwedenSound
            </Link>
            <p className="mt-2 text-sm text-gray-500 leading-relaxed max-w-xs">
              Профессиональная акустика и микрофонные системы. Европейское звучание, доступное каждому.
            </p>
          </div>

          {/* Navigation */}
          <div className="flex flex-col items-start md:items-end">
            <h4 className="text-xs font-semibold uppercase tracking-[0.12em] text-gray-400 mb-4">
              Навигация
            </h4>
            <div className="flex flex-col gap-2 items-start md:items-end">
              <Link to="/" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                Главная
              </Link>
              <Link to="/catalog" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                Каталог
              </Link>
              <Link to="/about" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                О нас
              </Link>
              <Link to="/contacts" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                Контакты
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} SwedenSound. Все права защищены.
          </p>
          <div className="flex gap-6">
            <span className="text-xs text-gray-400">SwedenSound — профессиональная акустика</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
